import { useState } from "react";
import { Card, CardBody, Table, TabPane } from "reactstrap";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";
import DefaultButton from "../../../../../components/Buttons/Default";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import CreateCallResultModal from "../Modals/CreateCallResult";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { useTranslation } from "react-i18next";

function CallResultsTab({ callResults, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [resultToDelete, setResultToDelete] = useState(null);
  const [resultToEdit, setResultToEdit] = useState(null);

  const deleteCallResult = async () => {
    const data = await del(`/crm/settings/call-results/delete/${resultToDelete}`);
    if(data?.success) {
      refreshSettings();
      setResultToDelete(null);
      toast.success(t('crm.settings.call_results.deleted'));
    }
  }

  return(
    <TabPane tabId="call-results">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              { t('crm.settings.call_results.title') }
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setResultToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('common.color') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {callResults?.map((data, key) => (
                <tr key={key}>
                  <td>{ data.name }</td>
                  <td>
                    <div style={{ width: '20px', height: '20px', backgroundColor: data.color }}></div>
                  </td>
                  <td>{ data.created_by?.firstname + ' ' + data.created_by?.lastname }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setResultToEdit(data);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setResultToDelete(data.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateCallResultModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(false)}
        refreshSettings={refreshSettings}
        resultToEdit={resultToEdit}
      />

      <ConfirmationModal
        isOpen={resultToDelete !== null}
        title={t('crm.settings.call_results.deleteTitle')}
        message={t('crm.settings.call_results.deleteMessage')}
        onConfirm={deleteCallResult}
        toggle={() => setResultToDelete(null)}
      />
    </TabPane>
  );
}

export default CallResultsTab;